import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { CheckBox } from "./check-box";
import { BaseFieldEditorComponent } from "../../base-field-editor.component";

@Component({
    selector: "check-box-editor",
    templateUrl: "./check-box-editor.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckBoxEditorComponent extends BaseFieldEditorComponent implements OnInit, OnDestroy {
    constructor(_changeDetector: ChangeDetectorRef, private _formBuilder: FormBuilder) {
        super(_changeDetector);
    }

    ngOnInit(): void {
        this.form = this._formBuilder.group({
            // placeholder: [this.CheckBox.placeholder]
        });
        super.onInit();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    get checkBox() {
        return this.field as CheckBox;
    }
}
